var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Listagem',{attrs:{"lista":_vm.vocabulariosControladosContinuacao,"tipo":"Termos de Vocabulários Controlados","cabecalho":['Termo', 'Descrição', 'Identificador'],"campos":['termo', 'desc', 'idtermo']}})}
var staticRenderFns = []

export { render, staticRenderFns }